import React from "react";
import PropTypes from "prop-types";

import { H2, Body3, Body4, InternalLink } from "../../Typography/index";
import theme from "../../../design/theme";
import {
  BannerTitleSection,
  ProfileSkeleton,
  BackIcon,
  Avatar,
  NameWrapper,
} from "../styles";

function BannerHeaderSection({ profile }) {
  return (
    <BannerTitleSection>
      <H2
        textAlign="left"
        margin={`0 0 ${theme.lg}px 0`}
        color={theme.neutrals.white}
      >
        My account
      </H2>
      <ProfileSkeleton>
        <InternalLink to="/">
          <BackIcon />
        </InternalLink>
        <Avatar
          src="/images/profile-page/avatar-outline.png"
          alt="Avatar Outline"
        />
        <NameWrapper>
          <Body3
            color={theme.neutrals.white}
            margin={`0 0 ${theme.xs}px 0`}
            fontWeight="600"
            textAlign="left"
          >
            Profile
          </Body3>
          <Body4 color={theme.neutrals.white} textAlign="left">
            {profile?.name || "Loading..."}
          </Body4>
        </NameWrapper>
      </ProfileSkeleton>
    </BannerTitleSection>
  );
}

BannerHeaderSection.propTypes = {
  profile: PropTypes.shape({
    name: PropTypes.string,
  }),
};

export default BannerHeaderSection;
